export default {
  setLoading (state, val) {
    state.loading = !!val
  },
  setFirebaseUser (state, user) {
    state.firebaseUser = user || null
  },
  setFirebaseIdToken (state, token) {
    state.firebaseIdToken = token || null
  },
  setMe (state, me) {
    state.me = me || null
  },
  setAuthRedirectError (state, val) {
    state.authRedirectError = val || null
  },
  setAuthRedirectDebug (state, val) {
    state.authRedirectDebug = val || null
  }
}
